function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var DevCardOverlayTemplate = require('./dev-card.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var DevCardOverlay = /*#__PURE__*/function () {
  function DevCardOverlay(app, mod) {
    _classCallCheck(this, DevCardOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod);
  }
  return _createClass(DevCardOverlay, [{
    key: "render",
    value: function render() {
      this.overlay.show(DevCardOverlayTemplate(this.app, this.mod, this));
      this.attachEvents();
      console.log('DEV CARDS: ' + JSON.stringify(this.mod.deck));
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      this_dev_card = this;
      document.querySelectorAll('.settlers-dev-card').forEach(function (card) {
        card.onclick = function (e) {
          var target = e.currentTarget;
          if (target.classList.contains('settlers-card-disabled')) {
            salert('You cannot play that card now');
            return;
          }
          var selection = target.getAttribute('id');
          var card = this_dev_card.mod.game.state.players[this_dev_card.mod.game.player - 1].devcards[selection];
          var cardobj = this_dev_card.mod.game.deck[0].cards[card];
          this_dev_card.overlay.remove();
          switch (cardobj.action) {
            case 1:
              //Soldier/Knight
              this_dev_card.mod.addMove("play_knight\t".concat(this_dev_card.mod.game.player, "\t").concat(cardobj.card));
              this_dev_card.mod.endTurn();
              break;
            case 2:
              this_dev_card.mod.year_of_plenty.player = this_dev_card.mod.game.player;
              this_dev_card.mod.year_of_plenty.cardname = cardobj.card;
              this_dev_card.mod.year_of_plenty.render(card);
              break;
            case 3:
              this_dev_card.mod.monopoly.player = this_dev_card.mod.game.player;
              this_dev_card.mod.monopoly.cardname = cardobj.card;
              this_dev_card.mod.monopoly.render(card);
              break;
            case 4:
              this_dev_card.mod.game.state.canPlayCard = false; //No more cards this turn
              this_dev_card.mod.addMove('player_build_road\t' + this_dev_card.mod.game.player);
              this_dev_card.mod.addMove('player_build_road\t' + this_dev_card.mod.game.player);
              this_dev_card.mod.addMove("road_building\t".concat(this_dev_card.mod.game.player, "\t").concat(cardobj.card));
              this_dev_card.mod.endTurn();
              break;
            default:
              //victory point
              this_dev_card.mod.addMove("vp\t".concat(this_dev_card.mod.game.player, "\t").concat(cardobj.card));
              this_dev_card.mod.endTurn();
          }
          this_dev_card.mod.game.state.players[this_dev_card.mod.game.player - 1].devcards.splice(parseInt(selection), 1);
          this_dev_card.mod.game.state.canPlayCard = false; //No more cards this turn

          if (this_dev_card.mod.game.deck[0].hand.length == 0 && this_dev_card.mod.game.state.players[this_dev_card.mod.game.player - 1].devcards.length == 0) {
            $('#settlers-hud-controls #playcard').removeClass('enabled');
          }
        };
      });
    }
  }]);
}();
module.exports = DevCardOverlay;